/**
 * Small "Recommended" pill shown next to a field label on the New Login form.
 * Soft-teal styling (surface-alt fill, primary text) so it reads as a gentle
 * nudge, not an error/warning. The tooltip carries the fuller guidance.
 */
export function RecommendedBadge(): JSX.Element {
  return (
    <span
      title="Recommended — add this unless you have a reason not to."
      className="inline-block align-middle rounded-hbs-sm bg-hbs-surface-alt px-1.5 py-0.5 text-[9px] font-extrabold uppercase tracking-hbs-overline text-hbs-primary"
    >
      Recommended
    </span>
  );
}
